export const DATETIME_FORMAT = 'MMM dd, yyyy h:mm:ss a';
export const DATE_FORMAT = 'MMM dd, yyyy';

export const isValidUniversalTimestamp = (universalTimestamp: any) => {
  return (
    !!universalTimestamp &&
    typeof universalTimestamp.toDate === 'function' &&
    !isNaN(universalTimestamp.toDate())
  );
};

export const safeUniversalTimestampToDate = (universalTimestamp: any) => {
  if (!universalTimestamp || !isValidUniversalTimestamp(universalTimestamp)) {
    return undefined;
  }
  return universalTimestamp.toDate();
};
